export enum PublicKeyDisplayMode {
  LONG = "long",
  SHORT = "short",
}
